import React from 'react';
import { useTranslation } from 'react-i18next';
import type { KnowledgeReference } from '../../../types/drbfm';
import { formatPercent } from './decisionMemoryText';

interface KnowledgeSummaryListProps {
  references: KnowledgeReference[];
}

const KnowledgeSummaryList: React.FC<KnowledgeSummaryListProps> = ({ references }) => {
  const { t } = useTranslation();

  return (
    <div>
      <p className="revy-cjk mb-2 text-sm font-medium leading-[1.5]">
        {t('drbfm.decisionMemory.relatedKnowledgeSummary', '関連知識サマリー')}
      </p>
      <div className="flex flex-col gap-1.5">
        {references.slice(0, 3).map((reference) => (
          <div key={`${reference.documentId}-${reference.title}`}>
            <p className="revy-cjk text-sm font-semibold leading-[1.5]">
              {reference.fileName || reference.title}
            </p>
            <p className="revy-cjk revy-figure text-xs leading-[1.5] text-muted-foreground">
              {t('drbfm.decisionMemory.relevance', {
                value: formatPercent(reference.relevanceScore),
                defaultValue: `関連度 ${formatPercent(reference.relevanceScore)}`,
              })}
              {reference.pageNumber ? ` / p.${reference.pageNumber}` : ''}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KnowledgeSummaryList;
